import React, { useState } from "react";
import { getTranslations } from "../../../../Common/utils";
import PageLoader from "../../../../ReusableComponents/Loaders/PageLoader";
import useCloudinaryData from "../../../../Common/hooks/useCloudinaryData";
import { formatDate } from "../../../../Common/utils";
import {
  CLOUDINARY_IMAGE_BASE_URL,
  IMAGE_VERSION,
} from "../../../../Common/constants";

const About = ({ data, leagueName, leagueInfo }) => {
  const { cloudinaryBase, envVersion, currentSeasonYear } = useCloudinaryData();
  const [imgError, setImgError] = useState(false);

  const fallbackImageUrl = `${CLOUDINARY_IMAGE_BASE_URL}common/fallback.svg?v=${IMAGE_VERSION}`;

  const { description, cta, details, imageMob, image } = data;

  const imagePathMobile = imageMob
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear)
    ?.replaceAll("<mini_league_name>", leagueName);

  const imagePath = image
    ?.replaceAll("<cloudinary_base_path>", cloudinaryBase)
    ?.replaceAll("<env_version>", envVersion)
    ?.replaceAll("<current_season_year>", currentSeasonYear)
    ?.replaceAll("<mini_league_name>", leagueName);

  const iconMapping = {
    mini_landing_type: "f1i-battle",
    mini_landing_total_players: "f1i-profile",
    mini_landing_date_created: "f1i-calendar",
    mini_landing_admin: "f1i-shield",
  };

  // Type-based icon mapping as fallback
  const typeIconMapping = {
    league_type: "f1i-battle",
    total_players: "f1i-profile",
    date_created: "f1i-calendar",
    admin: "f1i-shield",
  };

  if (!data) {
    return <PageLoader />;
  }
  return (
    <>
      <div className="si-main__container">
        <div className="si-main__row">
          <div className="si-league__marketing-About-wrap">
            <div className="si-league__marketing-About-lhs">
              <div className="si-league__marketing-About-content">
                <p>
                  {getTranslations(
                    description,
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris auctor neque in odio cursus tempus. Aliquam sem magna, convallis vel vehicula ac, tempor luctus dolor. Aliquam et turpis ut mauris tempor laoreet. Morbi at porta urna. Nunc pellentesque ligula eget mattis fringilla."
                  )}
                </p>
              </div>
              {cta && getTranslations(cta.text) && (
                <div className="si-league__marketing-About-link">
                  <a href={cta.url} target="_blank" rel="noopener noreferrer">
                    {getTranslations(cta.text)}
                    <i className="f1i-redirect"></i>
                  </a>
                </div>
              )}
              {details && details.length > 0 && (
                <div className="si-league__marketing-About-footer">
                  {details.map((detail, index) => {
                    const key = detail.key || Object.keys(detail)[0];
                    const rawValue =
                      detail.value || detail[Object.keys(detail)[0]];
                    const type = detail.type;

                    let value =
                      type === "date_created" ? formatDate(rawValue) : rawValue;

                    if (key === "sponsor_landing_type" && value === "SPONSOR") {
                      value = "PUBLIC";
                    }

                    const iconClass =
                      iconMapping[key] ||
                      typeIconMapping[type] ||
                      "f1i-profile";

                    if (detail?.type === "admin") {
                      return null;
                    }

                    return (
                      <div
                        key={index}
                        className="si-league__marketing-About-details"
                      >
                        <i className={iconClass}></i>
                        <span>
                          {getTranslations(
                            key,
                            key
                              .replace(/mini_landing_|_/g, " ")
                              .replace(/\b\w/g, (l) => l.toUpperCase())
                          )}
                        </span>
                        <span>
                          {detail?.type === "total_players"
                            ? leagueInfo?.memberCount
                            : value}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="si-league__marketing-About-rhs">
              <div className="si-league__marketing-About-thumb">
                <picture>
                  <source
                    media="(min-width: 992px)"
                    srcSet={
                      imgError || !imagePath ? fallbackImageUrl : imagePath
                    }
                  />
                  <source
                    media="(min-width: 768px)"
                    srcSet={
                      imgError || !imagePath ? fallbackImageUrl : imagePath
                    }
                  />
                  <img
                    src={
                      imgError || !imagePathMobile
                        ? fallbackImageUrl
                        : imagePathMobile
                    }
                    alt="About image"
                    loading="lazy"
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = fallbackImageUrl;
                      setImgError(true);
                    }}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
